module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex active-item align-initial "
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.adImage,
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.item.status === 2) ? _c('div', {
    staticClass: "jobf-status",
    staticStyle: {
      "background": "#A4A4A4"
    }
  }, [_c('div', [_vm._v("已结束")])]) : _c('div', [(_vm.item.isSign) ? _c('div', {
    staticClass: "jobf-status"
  }, [_c('div', [_vm._v("已报名")])]) : _vm._e(), _vm._v(" "), (!_vm.item.isSign && _vm.item.status === 1) ? _c('div', {
    staticClass: "jobf-status"
  }, [_c('div', [_vm._v("报名中")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex flex-column flex-between align-start"
  }, [_c('div', {
    staticClass: "flex m-b-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "ac-type"
  }, [_vm._v(_vm._s(_vm.item.type === 1 ? '线上' : '线下'))])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "line flex"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/home/user_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-right": "55px"
    }
  }, [_vm._v("主办方：" + _vm._s(_vm.item.sponsor))]), _vm._v(" "), _c('p', [_vm._v("限额：" + _vm._s(_vm.item.signLimit) + "家")])]), _vm._v(" "), _c('div', {
    staticClass: "line flex"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/home/time-circle_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("截止时间：" + _vm._s(_vm.item.signEndat))])]), _vm._v(" "), _c('div', {
    staticClass: "line flex"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/home/location_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("参会地址：" + _vm._s(_vm.item.address))])])])]), _vm._v(" "), (_vm.itemType === 'detail' && _vm.item.status !== 2 && !_vm.item.isSign) ? _c('div', {
    staticClass: "button-list flex flex-end"
  }, [_c('div', {
    staticClass: "button primary-btn m-l-24",
    on: {
      "click": _vm.goSign
    }
  }, [_vm._v("立即报名")])]) : _vm._e(), _vm._v(" "), (_vm.itemType !== 'detail') ? _c('div', {
    staticClass: "button-list flex flex-end"
  }, [_c('div', {
    staticClass: "button",
    class: _vm.item.status === 2 ? 'gray-btn' : 'primary-border-btn',
    on: {
      "click": _vm.goDetail
    }
  }, [_vm._v("查看详情")]), _vm._v(" "), (!_vm.item.isSign && _vm.item.status !== 2) ? _c('div', {
    staticClass: "button primary-btn m-l-24",
    on: {
      "click": _vm.goDetail
    }
  }, [_vm._v("立即报名")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73af593b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityItem.vue
// module id = 893
// module chunks = 1